import classNames from 'classnames'

import { ButtonCopy } from '@apps-common/components/elements/button/ButtonCopy'
import { commonIcons } from '@apps-common/config/icons'

interface IProps {
  label: string
  value: string
  allowCopy?: boolean
  callbackDisabled?: boolean
  callbackHidden?: boolean
  callback?: () => void
  loading?: boolean
  classes?: string
}

export const DetailsItemAction: React.FC<IProps> = ({
  label,
  value,
  allowCopy,
  callbackDisabled,
  callbackHidden,
  callback,
  loading,
  classes
}) => (
  <>
    {loading && (
      <div className='animate-pulse'>
        <div className='h-[18px] w-[60%] bg-skeleton rounded mb-[4px]' />
        <div className='h-[24px] w-[40%] bg-skeleton rounded' />
      </div>
    )}
    {!loading && (
      <div className={classes}>
        <div className='jost text-[0.8em] sm:text-[0.9em] text-text-muted'>{label}</div>
        <div className='text-[0.85em] sm:text-[1em] jost-light text-text flex items-center text-nowrap'>
          {(!callback || callbackHidden) && <div className='text-ellipsis overflow-hidden'>{value}</div>}
          {callback && !callbackHidden && (
            <button
              type='button'
              aria-label='Action button'
              disabled={callbackDisabled}
              className={classNames(!callbackDisabled && 'hover:opacity-70', 'flex items-center justify-start max-w-[90%]')}
              onClick={() => {
                callback()
              }}
            >
              <div className='text-ellipsis overflow-hidden'>{value}</div>
              <div className={classNames(callbackDisabled && 'opacity-30', 'ml-[5px] rounded-full p-[1px] border border-text-muted')}>
                <commonIcons.arrowAngled className='text-[0.85em]' />
              </div>
            </button>
          )}
          {allowCopy && <ButtonCopy value={value} />}
        </div>
      </div>
    )}
  </>
)
